"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
const three_1 = require("three");
// eslint-disable-next-line import/no-cycle
const types_1 = require("~/store/types");
const PlasticPanelCutouts_3d_1 = require("../classes/PlasticPanelCutouts.3d");
// eslint-disable-next-line import/no-cycle
const Command_1 = require("./Command");
// eslint-disable-next-line import/no-cycle
const events_1 = require("../../../utils/events");
// eslint-disable-next-line import/no-cycle
const RemoveObjectCommand_1 = __importDefault(require("./RemoveObjectCommand"));
const utils_3d_1 = require("../utils/utils.3d");
const utils_1 = require("../utils");
class AddObjectCommand extends Command_1.ViewerCommand {
    constructor(objects, viewer, historyService, parent, postInsertConnectionPromises) {
        super();
        this.type = 'AddObjectCommand';
        this.objects = objects;
        this.viewer = viewer;
        this.designProMain = viewer.getDesignProMain();
        this.historyService = historyService;
        this.parent = parent !== null && parent !== void 0 ? parent : viewer.getScene();
        this.postInsertConnectionPromises = postInsertConnectionPromises;
        this.name = 'Add Object: ';
        this.objects.forEach((object) => {
            this.name += `${object.name}; `;
        });
    }
    // eslint-disable-next-line class-methods-use-this
    update() {
        /* do nothing */
    }
    execute(appliedFromHistory) {
        var _a, _b;
        if (!this.objects.length) {
            return;
        }
        this.historyService.emit(`${this.objects[0].type}Added`, this.objects); // TODO: should be rewritten in future
        this.objects.forEach((object) => {
            this.parent.add(object);
            this.viewer.collisionProcessor.notifyObjectAdded(object);
            object.oldCoord = object.position.clone();
        });
        if (!(0, utils_3d_1.isFastener)(this.objects[0])) {
            if (!(0, PlasticPanelCutouts_3d_1.refreshPlasticPanelsOrRollback)(this.viewer, appliedFromHistory, () => {
                this.objects.forEach((object) => {
                    this.viewer.collisionProcessor.notifyObjectRemoved(object);
                    this.designProMain.connectionManager.updateConnections(object);
                    object.removeFromParent();
                });
                this.viewer.getDesignProMain().objectsInsertingIsFinished = true;
                this.designProMain.resetLastScaledObject();
            })) {
                return;
            }
        }
        const connectionsPromises = this.designProMain.updateConnectionsAndShowNotifications(...this.objects);
        this.designProMain.capHelper.updateCones();
        Promise.all(connectionsPromises.concat((_b = (_a = this.postInsertConnectionPromises) === null || _a === void 0 ? void 0 : _a.call(this)) !== null && _b !== void 0 ? _b : [])).then((connectionObjects) => {
            this.viewer.collisionProcessor.updateCollisionsForObjectsAndConnections(this.objects, connectionObjects.filter((connectionObject) => connectionObject !== null));
            const events = [];
            this.objects.forEach((object) => {
                var _a, _b, _c, _d;
                const connections = this.viewer.getDesignProMain().connectionManager.getRelatedConnections(object);
                if (object.copyInfo) {
                    connections.forEach((connection) => {
                        var _a;
                        const connectedItem = connection.items[0].uuid !== object.uuid ? connection.items[0] : connection.items[1];
                        const connectionObject = this.viewer
                            .getDesignProMain()
                            .connectionManager.getConnectionObject(connection.items[0].uuid, connection.items[1].uuid);
                        const fastenersMetadata = connectionObject === null || connectionObject === void 0 ? void 0 : connectionObject.getFastenersMetadata();
                        connection.actionType = types_1.ACTION_TYPE.COPY;
                        (_a = object.copyInfo) === null || _a === void 0 ? void 0 : _a.fasteners.forEach((fastenerData) => {
                            var _a;
                            const connectedCopyObject = this.objects.find((obj) => {
                                var _a;
                                return fastenerData.toOriginObject === ((_a = obj.copyInfo) === null || _a === void 0 ? void 0 : _a.originObjectId);
                            });
                            if (connectedCopyObject && connectedCopyObject.uuid === connectedItem.uuid) {
                                connection.fastenerItemNumber = fastenerData.fastenerItemNumber;
                                connection.numberOfFasteners = (_a = fastenersMetadata === null || fastenersMetadata === void 0 ? void 0 : fastenersMetadata.length) !== null && _a !== void 0 ? _a : 1;
                                connection.fastenersMetadata = fastenersMetadata !== null && fastenersMetadata !== void 0 ? fastenersMetadata : [];
                            }
                        });
                    });
                }
                events.push({
                    actionType: types_1.ACTION_TYPE.ADD,
                    size: object.getLength(),
                    itemNumber: (_a = object.partDetails) === null || _a === void 0 ? void 0 : _a.itemNumber,
                    itemType: object.type,
                    geomkernelPosition: object.position,
                    position: (_b = object.originalPosition) !== null && _b !== void 0 ? _b : object.position,
                    uuid: object.uuid,
                    connections,
                    slicePlanes: object.slicePlanes,
                    panelCutoutGeometry: utils_1.Utils.isPlasticPanel(object) ? (0, PlasticPanelCutouts_3d_1.getPersistedPanelCutouts)(object) : undefined,
                    geomkernelPanelSize: object.getSize(),
                    panelSize: (_c = object.originalPanelSize) !== null && _c !== void 0 ? _c : object.getSize(),
                    rotation: {
                        x: object.quaternion.x,
                        y: object.quaternion.y,
                        z: object.quaternion.z,
                        w: object.quaternion.w,
                    },
                    appliedFromHistory,
                    hasSwappedMetadataPoints: object.hasSwappedMetadataPoints,
                    isCopyPaste: !!object.copyInfo,
                    isAiAction: !!((_d = object.userData) === null || _d === void 0 ? void 0 : _d.aiAssemblyId),
                });
            });
            // TODO: remove later
            if ((0, utils_3d_1.isFastener)(this.objects[0])) {
                return;
            }
            document.body.dispatchEvent((0, events_1.addItemsToBOMEvent)(events));
            this.viewer.getDesignProMain().objectsInsertingIsFinished = true;
            this.designProMain.resetLastScaledObject();
        });
    }
    undo() {
        new RemoveObjectCommand_1.default(this.objects, this.viewer, this.historyService).execute(false);
    }
    toJSON() {
        const JSONObjects = [];
        this.objects.forEach((object) => {
            JSONObjects.push(object.toJSON());
        });
        return {
            type: this.type,
            id: this.id,
            name: this.name,
            object: JSONObjects,
        };
    }
    fromJSON(json) {
        this.objects = [];
        json.object.forEach((object) => {
            if (this.viewer.getObjectById(object.uuid) === undefined) {
                const loader = new three_1.ObjectLoader();
                this.objects.push(loader.parse(object));
            }
        });
    }
}
exports.default = AddObjectCommand;
